"use client";
import { sendContactForm } from "@/api/api";
import { Geo, Sms, Tel } from "@/assets/icons/Icons";
import { useTranslations } from "next-intl";
import { useState } from "react";
export default function Contact() {
  const t = useTranslations("Contact");

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;

    if (name === "phone_number") {
      // Telefon raqami faqat raqam va "+" bilan boshlanishi uchun validatsiya
      if (!/^\+?[0-9]*$/.test(value)) return;
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    const response = await sendContactForm(formData);

    if (response) {
      setSuccess(true);
      setFormData({
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        message: "",
      });

      setTimeout(() => {
        setSuccess(false);
      }, 6000);
    }

    setLoading(false);
  };

  return (
    <div
      id="contact"
      className="container  xl:px-[120px] xl:pt-[120px] pt-[41px] lg:pt-[80px] md:pt-[50px] px-4"
    >
      <div className="flex flex-col justify-center items-center gap-6">
        <h1 className="font-extrabold xl:text-5xl lg:text-[42px] text-[32px] text-center pt-[41px] lg:pt-0">
          {t("title")}
        </h1>
        <p className="lg:text-[20px] text-base font-medium text-center lg:pt-6 pt-2">
          {t("text")}
        </p>

        <div className="w-full xl:max-w-full rounded-lg">
          <div className="flex flex-col md:flex-row md:gap-24 md:justify-around w-full pt-4 xl:px-24 lg:px-16">
            <div className="flex flex-col mb-8 md:mb-0 md:w-full bg-red-20">
              <div className="mb-8 md:max-w-[400px]">
                <h2 className="text-2xl font-semibold mb-4">{t("wantSmth")}</h2>
                <p className="text-gray-600">{t("subtitle")}</p>
              </div>
              <div className="space-y-6">
                <div className="flex items-center gap-[10px]">
                  <Geo className="w-6 h-7 gap-1 flex" />
                  <div className="pr-1 flex flex-col">
                    <p>{t("adress1")}</p>
                    <p>{t("adress2")}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <Tel className="w-6 h-6" />
                  <a href="tel:+998900614837">+998(90) 061 48 37</a>
                </div>
                <div className="flex items-center gap-3">
                  <Sms className="w-[26px] h-[26px]" />
                  <a href="mailto:a.donets@wmsky.uz">a.donets@wmsky.uz</a>
                </div>
              </div>
            </div>

            <div className="w-full xl:p-10 lg:p-8 p-4 border border-[#C5C5C5] rounded-[32px]">
              <form className="space-y-4" onSubmit={handleSubmit}>
                <div className="flex flex-col md:flex-row gap-4">
                  <input
                    type="text"
                    name="first_name"
                    placeholder={t("name")}
                    value={formData.first_name}
                    onChange={handleChange}
                    required
                    className="w-full md:w-1/2 p-[10px] pl-3 rounded-lg border border-[#828282] focus:outline-none focus:border-primary"
                  />
                  <input
                    type="text"
                    name="last_name"
                    placeholder={t("lastname")}
                    value={formData.last_name}
                    onChange={handleChange}
                    required
                    className="w-full md:w-1/2 p-[10px] pl-3 rounded-lg border border-[#828282] focus:outline-none focus:border-primary"
                  />
                </div>
                <input
                  type="email"
                  name="email"
                  placeholder={t("email")}
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full p-[10px] pl-3 rounded-lg border border-[#828282] focus:outline-none focus:border-primary"
                />
                <input
                  type="tel"
                  name="phone_number"
                  placeholder={t("phone")}
                  value={formData.phone_number}
                  onChange={handleChange}
                  required
                  className="w-full p-[10px] pl-3 rounded-lg border border-[#828282] focus:outline-none focus:border-primary"
                />
                <textarea
                  name="message"
                  placeholder={t("sms")}
                  rows={6}
                  value={formData.message}
                  onChange={handleChange}
                  required
                  className="w-full p-3 rounded-lg border border-[#828282] focus:outline-none focus:border-primary resize-none"
                />
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full font-semibold bg-primary text-white py-3 rounded-3xl hover:bg-red-600 transition-colors"
                >
                  {loading ? t("sending") : t("send")}
                </button>
              </form>

              {success && (
                <p className="text-green-600 text-center mt-4">
                  {t("success")}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
